import { render, staticRenderFns } from "./BuildFund.vue?vue&type=template&id=ca70ffca&"
import script from "./BuildFund.vue?vue&type=script&lang=js&"
export * from "./BuildFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports